import React from "react";

const setCookie = (name, value, days = 7, options = {}) => {
  const expires = new Date();
  expires.setDate(expires.getDate() + days);

  const isIframe = typeof window !== "undefined" && window.top !== window.self;
  const isHttps = typeof window !== "undefined" && window.location.protocol === "https:";

  const sameSite = options.sameSite || (isIframe ? "None" : "Lax");

  let cookieValue = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  if (sameSite) {
    cookieValue += `;SameSite=${sameSite}`;
  }
  if (sameSite === "None") {
    // Secure is required for SameSite=None; browsers will ignore on non-HTTPS
    cookieValue += ";Secure";
  }

  document.cookie = cookieValue;

  // Fallback for third-party iframe on non-HTTPS (cookies may be blocked)
  if (isIframe && !isHttps) {
    try {
      localStorage.setItem(name, value);
    } catch (e) {
      // ignore storage errors
    }
  }
};

export default setCookie;
